import { FormDataAccountType } from ".";

export const emptyValues: FormDataAccountType = {
  country: "US",
  type: "Business",
  representativeConfirmation: false,
  isUsPerson: false
};
